module.exports = __webpack_public_path__ + "img/logo.49e30802.svg";